{
  "ui": {
    "feedback": "Geri bildirim",
    "credits": "Emeği geçenler",
    "currentMaintainer": "Güncel bakım sorumlusu",
    "maintainerPeriod": "2026 ve sonrası",
    "originalTeam": "Orijinal ekip",
    "creditsCampaigns": "Orman ve Noel",
    "moreSettings": "Diğer ayarlar",
    "chooseLanguage": "Dilini seç",
    "notebookTools": "Defter araçları",
    "visualGuide": "Resimli rehber",
    "templeSoon": "Çok yakında",
    "playAdventure": "Oyna",
    "story": "Hikâye",
    "loadingAdventure": "Maceraya hazırlanıyoruz…",
    "storyOpening": "Ormana bir okul gezisi. Marco ve Sophia arkadaşlarıyla keşfe çıkıyor. Renkli bir kuş Marco’nun dikkatini çekiyor, o da kuşu ağaçların arasına kadar takip ediyor. Birden yalnız kalıyor. Kaşiflerin yollarını bulmalarına yardım et!",
    "storyEnding": "Marco ve Sophia kayıp tapınağa birlikte ulaşıyor. Gizemli bir yüz girişi koruyor. Yeni bir macera onları bekliyor!",
    "blockCategories": "Defter sekmeleri",
    "actions": "Hareketler",
    "loops": "Döngüler",
    "conditions": "Koşullar",
    "title": "Run Marco! — Defterinde bir macera",
    "home": "Run Marco ana sayfa",
    "map": "Macera haritası",
    "worlds": "Bir macera seç",
    "notebook": "Defterim",
    "notebookToggle": "Defteri aç veya kapat",
    "notebookOpen": "Defteri aç",
    "notebookClose": "Yolu izle",
    "page": "Sayfa {number}",
    "level": "Parkur {number}",
    "run": "Haydi!",
    "stop": "Durdur",
    "step": "Bir adım",
    "stepTitle": "Bir komut çalıştır",
    "reset": "Başlangıca dön",
    "add": "Ekle",
    "addLabel": "Eklenecek bir blok seç",
    "addHint": "Blokları birleştir, sonra Oyna’ya bas.",
    "undo": "Geri al",
    "clear": "Yeni sayfa",
    "hint": "Küçük bir ipucu",
    "help": "Nasıl oynanır",
    "settings": "Ayarlar",
    "language": "Oyun dili",
    "blockLanguage": "Blok dili",
    "blockLanguageNote": "Bloklar için başka bir dil seçebilirsin.",
    "musicOn": "Sesi aç",
    "musicOff": "Sesi kapat",
    "sound": "Müzik ve ses efektleri",
    "speed": "Macera hızı",
    "chooseExplorer": "Kaşifini seç",
    "explorer": "Kaşif",
    "marco": "Marco",
    "sophia": "Sophia",
    "close": "Kapat",
    "done": "Keşfe çıkalım!",
    "loading": "Yolu buluyoruz…",
    "loadError": "Macera yüklenemedi. Yeniden denemek için sayfayı yenile.",
    "imageError": "Bazı resimler yüklenemedi. Sayfayı yenile.",
    "gemGoal": "Mücevheri bul",
    "goal": "Altın yıldızı bul",
    "cover": "Her kareyi yalnızca bir kez aydınlat",
    "lit": "{count} / {total} kare aydınlandı",
    "explored": "{count} / {total} parkur keşfedildi",
    "facing": "Yön: {direction} {arrow}",
    "boardLabel": "{name}, {level} parkurunda. Yön: {direction}. {steps}. {objective}.",
    "up": "yukarı",
    "down": "aşağı",
    "left": "sol",
    "right": "sağ",
    "steps_one": "{count} adım",
    "steps_other": "{count} adım",
    "blocks_one": "{count} blok",
    "blocks_other": "{count} blok",
    "stars_one": "{count} yıldız",
    "stars_other": "{count} yıldız",
    "place": "Blok ekle",
    "atEnd": "En sona",
    "insideRepeat": "Tekrar {number} içine",
    "insideIf": "Eğer {number} içine",
    "insideElse": "Değilse {number} içine",
    "readyFirst": "Küçük bir adım. Bir ileri bloğu ekle ve başlayalım!",
    "ready": "Nereye gidelim? Defterinde bir plan yap.",
    "back": "Başlangıca döndük. Blokların yeniden denemeye hazır.",
    "empty": "Önce defterine bir blok ekle.",
    "win": "Yolu buldun!",
    "winCover": "Yolu aydınlattın!",
    "winDetails": "{steps} · {blocks}",
    "brilliant": "Ne maceraydı ama!",
    "simpler": "Daha az blokla yapabilir misin?",
    "complete": "Parkur tamamlandı! En iyi yıldızların kaydedildi.",
    "next": "Sonraki parkur",
    "allWorlds": "Başka maceralar",
    "replay": "Yeniden oyna",
    "shortGoal": "Az kaldı! Yıldıza ulaşmak için birkaç blok daha ekle.",
    "shortGem": "Az kaldı! Mücevhere ulaşmak için birkaç blok daha ekle.",
    "shortCover": "Bazı kareler hâlâ karanlık. Onlara nasıl ulaşabiliriz?",
    "checking": "Yola bakıyoruz…",
    "paused": "Durduk. Oyna’ya basınca en baştan başlar.",
    "going": "Yola çıkalım!",
    "stepped": "Bir adım daha yaklaştın. Devam etmek için Bir adım veya Oyna’ya bas.",
    "clueCover": "Bir kenardan başla ve şeklin tamamını dolaş. Zıplayarak bir kareyi aydınlatmadan üzerinden geçebilirsin.",
    "clueCondition": "Önündeki yola bak. Bir koşul, kaşifinin ne yapacağını seçmesine yardım eder.",
    "clueRepeat": "Hangi adımlar tekrarlanıyor? Bu düzeni bir tekrar bloğunun içine koy.",
    "clueForward": "İleri, kaşifinin baktığı yöndür. Yıldıza kadar olan kareleri say.",
    "clueGem": "İleri, kaşifinin baktığı yöndür. Mücevhere kadar olan kareleri say.",
    "clueTurn": "Dönmek yer değiştirmeden yönü değiştirir. Yolu parmağınla takip et.",
    "mapNote": "Bir parkur seç. En iyi yıldızların saklanır.",
    "mapLevel": "Parkur {number}: {name}. {stars}.",
    "locked": "Bunu açmak için önceki parkuru bitir.",
    "soundBlocked": "Macerayı duymak için ses düğmesine dokun.",
    "clearTitle": "Yeni bir sayfa açalım mı?",
    "clearNote": "Bu parkurdaki blokların silinir. Geri al ile onları geri getirebilirsin.",
    "keep": "Bloklarımı koru",
    "clearConfirm": "Blokları sil",
    "fresh": "Yeni bir sayfa. Sonraki planın bizi nereye götürecek?",
    "localProgress": "İlerlemen bu cihazda kaydedilir.",
    "helpBuild": "Bir plan yap",
    "helpBuildText": "Blokları deftere sürükleyip birleştir veya eklemek için bir bloğa dokun. Döngüye adım eklemek için «Tekrar içine» seçeneğini seç.",
    "helpTurn": "Kaşifini takip et",
    "helpTurnText": "İleri, baktığı yönü takip eder. Sol ve sağ yerinde döndürür. Zıplamak iki kare ilerletir.",
    "helpTry": "Dene, izle, yeniden dene",
    "helpTryText": "Planını denemek için Oyna’ya, tek komut için Bir adım’a bas. Kıvrık ok bloklarını koruyarak başlangıca döndürür.",
    "helpWorlds": "Her maceranın bir hedefi var",
    "helpWorldsText": "Ormanda mücevheri bul. Noel macerasında her açık kareyi bir kez aydınlat. Tapınakta ve Ege’de onarımları ve görünen hedefleri tamamlayıp çıkışa ulaş.",
    "noTrail": "Orada yol yok! İlerlemeden önce dönmeyi dene.",
    "broken": "O köprü kırık. Üzerinden zıplayabilir misin?",
    "blocked": "Yolda bir engel var. Zıplamayı veya başka bir yolu dene.",
    "alreadyLit": "O kare zaten aydınlandı. Her kareyi yalnızca bir kez ziyaret et.",
    "loopError": "Bu plan sürekli tekrarlanıyor. Döngüyü değiştirmeyi dene.",
    "repeatError": "1 ile 99 arasında bir tekrar sayısı seç.",
    "unsupported": "Desteklenmeyen bloğu kaldır ve yeniden dene.",
    "connect": "Bloklarını tek bir zincirde birleştir, sonra Oyna’ya bas.",
    "path": "yol",
    "backpack": "Sırt çantası",
    "templeGems": "Tapınağın mücevherleri",
    "gemsCollected": "Mücevherler: {count} / {total}",
    "gemsReady": "Tüm mücevherler toplandı!",
    "aegeanTitle": "Ege’nin Sırları",
    "harbour": "Liman",
    "aegeanDescription": "Limanı keşfet: istasyonları onar, yordamları yeniden kullan ve her iş emrine bir sayı gönder.",
    "templeBetaNote": "Beta · Bulmacaları ve dersleri gözden geçiriyoruz",
    "aegeanBetaNote": "Beta · Limandaki ilk 3 bölüm",
    "seasonal": "Mevsimlik macera",
    "choosePreview": "Bir önizleme bölümü seç",
    "repairs": "Onarımlar",
    "reachExit": "Çıkışa ulaş",
    "taskRequirements": "Görev hedefleri",
    "lessonGuided": "Rehberli alıştırma · verilen programı tamamla",
    "lessonRepair": "Hata ayıklama · verilen programı düzelt",
    "lessonChallenge": "Meydan okuma · kendi programını oluştur",
    "acc_define_parameter": "Yordam",
    "acc_call_argument": "Yordamı çağır",
    "acc_repeat_parameter": "Girdiyle tekrarla",
    "parameter": "parametre",
    "argument": "gönder",
    "callInput": "Bu çağrının girdisi",
    "inputWaiting": "Sonraki girdiyi görmek için programı çalıştır veya tek bir komut yürüt.",
    "argumentMismatch": "Parametreli bir yordam, sayı içeren bir çağrı ister. Parametresiz yordam için normal çağrı kullan.",
    "unsetParameter": "Parametreyi yalnızca onu alan yordamın içinde kullan. Parametreler ortak bellekten ayrıdır.",
    "memoryObjective": "Onarım kaydını ve çıkış hedeflerini kontrol et. Bunları karşılayan her program kabul edilir.",
    "gate": "Yol kapalı. Bitmemiş onarımları kontrol et.",
    "noPickup": "Aleti almadan önce bulunduğu karenin üzerine gel.",
    "creditLead": "Ekip liderliği ve yazılım geliştirme",
    "creditArt": "Çizim ve sahne tasarımı",
    "creditAnimation": "Animasyon",
    "creditUX": "Arayüz ve kullanıcı deneyimi tasarımı",
    "creditDesign": "Oyun tasarımı",
    "creditStory": "Hikâye yazımı",
    "creditAudio": "Müzik ve ses mühendisliği",
    "lightLamp": "Lambayı yak",
    "oilLamp": "Yağ kandili",
    "dustyStation": "tozlu istasyon",
    "betaLabel": "Beta",
    "noLamp": "Lambayı yakmadan önce sönük bir lambanın üzerinde dur.",
    "collected": "Araç alındı · kullanıma hazır",
    "dustyPrompt": "Fırçayı kullanmadan önce tozlu bir istasyonun üzerinde dur.",
    "lampMissing": "Önce yağ kandilini al. Sırt çantana bak.",
    "recursiveRoutine": "Bu yordam kendini çağırıyor. Başka bir yordam kullan; özyinelemeli çağrılar henüz kullanılamıyor."
  },
  "content": {
    "jungle.title": "Orman keşfi",
    "jungle.description": "Kayıp tapınağa giden yolu takip et.",
    "jungle-1": "İlk adımlar",
    "jungle-2": "Biraz daha ileri",
    "jungle-3": "Köşeyi dönünce",
    "jungle-4": "Yön değiştir",
    "jungle-5": "Yolu takip et",
    "jungle-6": "Yeni bir rota",
    "jungle-7": "Yeni yollar",
    "jungle-8": "Orman kavşağı",
    "jungle-9": "Yolunu bul",
    "jungle-10": "İleriyi düşün",
    "jungle-11": "Uzun yol",
    "jungle-12": "Kıvrımlı bir rota",
    "jungle-13": "Cesur bir sıçrayış",
    "jungle-14": "Örüntüler beliriyor",
    "jungle-15": "Ritmi tekrarla",
    "jungle-16": "Bir yol seç",
    "jungle-17": "Zıplamadan önce bak",
    "jungle-18": "Yolu oku",
    "jungle-19": "Akıllı bir dolambaç",
    "jungle-20": "Ağaçların altında",
    "jungle-21": "Köprü ustası",
    "jungle-22": "Nehrin ötesi",
    "jungle-23": "Harabeleri keşfet",
    "jungle-24": "Taş ve ahşap",
    "jungle-25": "Daha büyük bir sıçrayış",
    "jungle-26": "İpuçlarını takip et",
    "jungle-27": "Daha yukarı",
    "jungle-28": "Keşfetmeye devam",
    "jungle-29": "Kıvrılan yollar",
    "jungle-30": "Gizli bahçe",
    "jungle-31": "Gizli örüntüler",
    "jungle-32": "Antik yollar",
    "jungle-33": "Son dönüşler",
    "jungle-34": "Tapınağa doğru",
    "jungle-35": "Neredeyse geldik",
    "jungle-36": "Kayıp tapınak",
    "winter.title": "Kış yolu",
    "winter.description": "Her ayak izinde bir ışık bırak.",
    "winter-1": "Karda adımlar",
    "winter-2": "Farklı bir yön",
    "winter-3": "Donmuş köşeler",
    "winter-4": "Uzun dolambaç",
    "winter-5": "Kar tanesi",
    "winter-6": "Kış döngüleri",
    "winter-7": "Buz kaşifi",
    "winter-8": "Kıvrımlar ve dönüşler",
    "winter-9": "Buz gibi mantık",
    "winter-10": "Örüntü avcısı",
    "winter-11": "Yol ustası",
    "winter-12": "Kış harikası",
    "temple.title": "Kayıp tapınak",
    "temple.description": "Birbirine bağlı kırk oda: aletler, bellek ve kendi yordamlarınla göksel aygıtı onar."
  },
  "blockly": {
    "ARIA_LABEL_TRASH_EMPTY": "Çöp kutusu boş",
    "OPEN_TRASH": "Çöp kutusunu aç",
    "BLOCK_LABEL_BEGIN_STACK": "Zincir başlangıcı",
    "WORKSPACE_LABEL_1_STACK": "1 blok zinciri",
    "WORKSPACE_LABEL_MANY_STACKS": "%1 blok zinciri",
    "ARIA_TYPE_FIELD_NUMBER": "sayı",
    "ARIA_TYPE_FIELD_DROPDOWN": "açılır liste",
    "ARIA_TYPE_FIELD_IMAGE": "resim",
    "WORKSPACE_LABEL_PLAIN": "Defterim",
    "FIELD_LABEL_EDIT_PREFIX": "Düzenle: %1",
    "BLOCK_LABEL_HAS_INPUT": "girişi var",
    "BLOCK_LABEL_HAS_INPUTS": "girişleri var",
    "BLOCK_LABEL_HAS_BRANCHES": "%1 dalı var",
    "FIELD_LABEL_OPTION_INDEX": "Seçenek %1",
    "INPUT_LABEL_EMPTY": "Boş",
    "BLOCK_LABEL_DISABLED": "devre dışı",
    "BLOCK_LABEL_COLLAPSED": "daraltılmış",
    "BLOCK_LABEL_BEGIN_PREFIX": "Başlangıç: %1",
    "INPUT_LABEL_END_STATEMENT": "Son: %1",
    "ARIA_TYPE_FIELD_TEXT_INPUT": "metin",
    "ARIA_TYPE_FIELD_INPUT": "girdi",
    "ARIA_TYPE_FIELD_TEXT_INPUT_ARGUMENT": "girdi adı",
    "ARIA_TYPE_FIELD_TEXT_INPUT_PROCEDURE": "yordam adı"
  }
}
